export default {"src":"/_next/static/media/linkedin_icon_black.d28c248d.svg","height":56,"width":56};